var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 38,
  width: 18,
  height: 3.2,
  rx: 1.2,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m14 12c0-3.9 3.1-7 7-7s7 3.1 7 7v26.5h-14z",
  fill: "#eef1f3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.4 12.2c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6v8.3h-7.2z",
  fill: "#333a40"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m22.4 9.6-3.9 5.6h2.4l-1.5 4.8 4-5.9h-2.4z",
  fill: "#4cc38a"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 25,
  r: 1.5,
  fill: "#4cc38a"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m27.6 24.5c4.6 0.4 6.4 3.2 6.4 7.2v4.5",
  fill: "none",
  stroke: "#333a40",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 31.6,
  y: 35.2,
  width: 4.8,
  height: 5.6,
  rx: 1.4,
  fill: "#333a40"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 32.9,
  y: 33.6,
  width: 2.2,
  height: 2.4,
  rx: 0.8,
  fill: "#5c6870"
});

function SvgEvCharger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvCharger);
export default __webpack_public_path__ + "static/media/ev-charger.abd86459ff4fbd012b46caea949dddec.svg";
export { ForwardRef as ReactComponent };